import { QUEUED_JOBS_TYPE } from '../../ComponentTypes';
import JobsQueuePage from './JobsQueuePage';
import JobsTablePage from './JobsTablePage';
import './JobsContainer.scss';

export default (options = {}) => {
  return options.jobType === QUEUED_JOBS_TYPE ? JobsQueuePage(options) : JobsTablePage(options);
};
